// extracted by mini-css-extract-plugin
export default {"Pre":"Pre_Pre__Uojh5"};